import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'

export const USERS_TOTAL_COUNT_ACTION_TYPES = generateApiActionTypes('USERS_TOTAL_COUNT')
export const USERS_COUNT_ACTION_TYPES = generateApiActionTypes('USERS_COUNT')
export const USERS_ACTION_TYPES = generateApiActionTypes('USERS')

type CountActionTypes = typeof USERS_TOTAL_COUNT_ACTION_TYPES | typeof USERS_COUNT_ACTION_TYPES
const getCount = (params = {}, actionTypes: CountActionTypes) => ({
  type: undefined,
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.users,
      params,
      group: 'count',
    },
    actionTypes: Object.keys(actionTypes),
  },
})

export const getUsersCount = (params = {}) => getCount(params, USERS_COUNT_ACTION_TYPES)

export const getUsersTotalCount = (params = {}) => getCount(params, USERS_TOTAL_COUNT_ACTION_TYPES)

export const getUsers = (params = {}) => ({
  type: '',
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.users,
      params,
    },
    actionTypes: Object.keys(USERS_ACTION_TYPES),
  },
})
